import { useQuery } from "react-query";
import { t } from "@/i18n-js/instance";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers/internalApi";
import type { Comment } from "@/react/types/Comment";
import { Typography } from "@circle-react-uikit/Typography";
import { AiAgentAvatar } from "../../../AiAgentAvatar";

export interface HistoryDetailViewCommentProps {
  body: {
    community_bot_profile_id: number;
  };
  log: {
    message: {
      response_details: {
        body: {
          message: string;
          post_id: number;
          id: number;
        };
      };
    };
  };
}

export const HistoryDetailViewComment = ({
  body,
  log,
}: HistoryDetailViewCommentProps) => {
  const { community_bot_profile_id: communityBotProfileId } = body;

  const { data: comment, isLoading } = useQuery<Comment>({
    queryKey: ["comments", log.message.response_details?.body?.id],
    queryFn: () =>
      reactQueryGet(
        internalApi.comments.show({ id: log.message.response_details.body.id }),
      ),
    retry: false,
  });

  return (
    <div className="flex flex-col gap-2">
      <div className="md:flex">
        <div className="w-1/4">
          <Typography.LabelSm weight="semibold">
            {t("settings.workflows.action_messages.ai_agents.ai_agent")}
          </Typography.LabelSm>
        </div>
        <div className="w-3/4">
          <AiAgentAvatar communityBotProfileId={communityBotProfileId} />
        </div>
      </div>
      <div className="md:flex">
        <div className="w-1/4">
          <Typography.LabelSm weight="semibold">
            {t("settings.workflows.action_messages.ai_agents.comment")}
          </Typography.LabelSm>
        </div>
        <div className="w-3/4">
          {comment ? (
            <a
              href={comment.show_url}
              target="_blank"
              className="text-sm"
              rel="noopener noreferrer"
            >
              {t("settings.workflows.action_messages.ai_agents.comment_link")}
            </a>
          ) : (
            <Typography.LabelSm>
              {t(
                `settings.workflows.action_messages.ai_agents.${isLoading ? "comment_loading" : "comment_not_found"}`,
              )}
            </Typography.LabelSm>
          )}
        </div>
      </div>
    </div>
  );
};
